import type { FC } from 'react';
import Star from '@mui/icons-material/Star';
import StarOutline from '@mui/icons-material/StarOutline';

interface StarToggleButtonProps {
  isSelected: boolean;
  onSelect: () => void;
  onDeselect: () => void;
  starColor?: 'primary' | 'disabled';
}

export const StarToggleButton: FC<StarToggleButtonProps> = (props) => {
  return props.isSelected ? (
    <Star
      sx={{ height: '20px', width: '20px', cursor: 'pointer' }}
      data-cy="favorite-star"
      onClick={props.onDeselect}
      color={props.starColor || 'primary'}
    />
  ) : (
    <StarOutline
      sx={{ height: '20px', width: '20px', cursor: 'pointer' }}
      data-cy="favorite-star-outline"
      onClick={props.onSelect}
      color={'disabled'}
    />
  );
};
